import { render, staticRenderFns } from "./origin-destination.vue?vue&type=template&id=c56d3878&scoped=true"
import script from "./origin-destination.vue?vue&type=script&lang=js"
export * from "./origin-destination.vue?vue&type=script&lang=js"
import style0 from "./origin-destination.vue?vue&type=style&index=0&id=c56d3878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56d3878",
  null
  
)

export default component.exports